import { CityInfoDto, emptyPagedCollection, IPagingData } from '@sr/dto';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { IRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import { cityListApi } from './apiSlice';

export const useCitiesList = (paging: IPagingData, filter?: URLSearchParams,) => {

  const { data: cities, isLoading, error } = cityListApi.useGetCitiesListQuery(   
    { paging, filter: filter?.toString() || '' },
    { refetchOnMountOrArgChange: true });

  const collection: IRemotePagedCollection<CityInfoDto> = {
    collection: cities || emptyPagedCollection,
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading,
  };

  return collection;
};
